import React from 'react'
import './introduction.scss'

function Introduction() {
  return (
    <div className='introduction' id='introduction'>
      <div className='header'>
        
      </div>
      <div className='details'>
        <h3>Hi There!</h3>
        <br />
        <h2>I'm Sanjay Anuchuri and I'm a</h2>
        <br />
        <br />
        <h1>Frontend Developer</h1>
        <br />
        <br />
        <p>I like to craft solid and scalable frontend products </p>
        <p style={{ paddingTop: '10px' }}>with great user experience.</p>
      </div>
    </div>
  )
}

export default Introduction
